{
  "Filter": "Filtro",
  "Search": "Ricerca",
  "Alarms": "Allarmi",
  "Warnings": "Avvertenze",
  "Users": "Utenti",
  "Coolers": "Coolers",
  "Active License": "Licenza attiva",
  "License Expired": "Licenza scaduta",
  "Grace Period": "Periodo di tolleranza",
  "Tenant Users": "Utenti concessionario",
  "Logout": "Logout",
  "Profile Update": "Aggiorna profilo",
  "Change Passowrd": "Cambia passowrd",
  "Change Email": "Cambia e-mail",
  "Dashboard": "Dashboard",
  "Manage": "Gestione",
  "Rules": "Regole",
  "License Expires On": "La licenza scade il",
  "Report": "Rapporto",
  "Tenant List": "Elenco concessionari",
  "Add Tenant": "Aggiungi concessionario",
  "Erp No": "N° Erp",
  "Tenant": "Concessionario",
  "License End Date": "Data fine licenza",
  "Tenant Email": "E-mail concessionario",
  "ERP Number": "Numero di ERP",
  "Maximum number of coolers": "Numero massimo di apparecchi per la refrigerazione",
  "License Expiration": "Scadenza licenza",
  "Tenant Details": "Dettagli concessionario",
  "TENANT EMAIL": "E-MAIL CONCESSIONARIO",
  "COOLERS": "APPARECCHI PER LA REFRIGERAZIONE",
  "Expire": "SCADE",
  "GEO LOCATION": "GEOLOCALIZZAZIONE",
  "ERP NO": "N° ERP",
  "UPDATE": "AGGIORNAMENTO",
  "Disable Tenant": "Disabilita concessionario",
  "Move Coolers": "SPOSTA APPARECCHI PER LA REFRIGERAZIONE",
  "Do you really want to disable": "Vuoi davvero disabilitare",
  "Cooler List": "Elenco apparecchi per la refrigerazione",
  "Search works on COOLER, COUNTRY, TAG/ALIAS columns only": "Cerca lavori soltanto nelle colonne APPARECCHIO PER LA REFRIGERAZIONE, PAESE, TAG/ALIAS",
  "Cooler": "Cooler",
  "Last Connected": "Ultima connessione",
  "Country": "Paese",
  "Tag/Alias": "Tag/Alias",
  "User Information": "Informazioni utente",
  "Add New User": "Aggiungi nuovi utenti",
  "Search works on ROLE, EMAIL, CREATE ALARMS, ACCESS TO columns only": "Cerca lavori soltanto nelle colonne RUOLO, EMAIL, CREA ALLARMI, ACCEDI A",
  "Role": "Ruolo",
  "Email": "E-mail",
  "Create Alarms": "Crea allarmi",
  "Access To": "Accedi a",
  "Add User Details": "Aggiungi dettagli utente",
  "Edit User Details": "Modifica dettagli utente",
  "All Countries Selected": "Tutti i Paesi selezionati",
  "Yes": "Sì",
  "No": "Nessun",
  "Alarm Information": "Informazioni allarmi",
  "Search works on UID, STATUS, COOLER, GEO LOCATION, RULE, ALARM TYPE, RESOURCE columns only": "Cerca lavori soltanto nelle colonne UID, STATO, APPARECCHIO PER LA REFRIGERAZIONE, GEOLOCALIZZAZIONE, TIPO ALLARME, RISORSA",
  "UID": "UID",
  "Geo Location": "Geolocalizzazione",
  "Status": "Stato",
  "Alarm Type": "Tipo allarme",
  "Rule": "Regola",
  "Resource": "Risorsa",
  "Alarm Rules": "Regole allarmi",
  "Add New Rule": "Aggiungi nuove regole",
  "Search works on ID, STATUS, ALARM NAME, SEVERITY columns only": "Cerca lavori soltanto nelle colonne ID, STATO, NOME ALLARME, GRAVITÀ",
  "All": "Tutte",
  "All Controller with Geo Location": "Tutti i controllori con geolocalizzazione",
  "ID": "ID",
  "Alarm Name": "Nome allarme",
  "Limit": "Limite",
  "Severity": "Gravità",
  "BACK": "INDIETRO",
  "Last Connected On": "Ultima connessione il",
  "Resources Data": "Dati risorse",
  "Tag Name": "Nome tag",
  "Update Tag or Alias Name": "Aggiorna Nome tag o alias",
  "Update": "Aggiorna",
  "Export": "Esporta",
  "DAY": "GIORNO",
  "WEEK": "SETTIMANA",
  "MONTH": "MESE",
  "Loading latest telemetry data ... ": "Caricamento dati telemetria più recenti... ",
  "Loading telemetry data ... ": "Caricamento dei dati di telemetria ...",
  "No Data to display": "Nessun dato da visualizzare",
  "Resources": "Risorse",
  "Min": "Min",
  "Max": "Max.",
  "Value": "Valore",
  "Timestamp": "Timbro orario",
  "Save": "Salva",
  "Cancel": "Annulla",
  "Save and Apply": "Salva e applica",
  "Move": "Mossa",
  "Add Alarm Details": "Aggiungi dettagli allarme",
  "Update Alarm Details": "Aggiorna dettagli allarme",
  "Controller": "Controller",
  "Limits": "Limiti",
  "Notified To": "Comunicato a",
  "Apply To": "Applica a",
  "Max Distance": "Distanza massima",
  "Controller Name": "Nome controllore",
  "All Controller In": "Tutti i controllori in",
  "High": "Alto",
  "Low": "Basso",
  "Parameters": "Parametros",
  "Parameter": "Parametro",
  "Select Controller": "Seleziona controllore",
  "Select Controllers": "Seleziona controllori",
  "Select Resource": "Seleziona risorsa",
  "Success Message": "Messaggio di avvenuta esecuzione",
  "Error": "Errore",
  "Are you sure to Delete User?": "Sei sicuro di voler cancellare l’utente?",
  "User deleted successfully.": "Utente cancellato con successo.",
  "Invalid Email": "E-mail non valida",
  "Email field should not be empty.": "Il campo e-mail non deve essere vuoto.",
  "Email entered is not a valid email.": "Il formato e-mail digitato non è valido.",
  "Invalid Role": "Ruolo non valido",
  "Select a role.": "Seleziona un ruolo.",
  "Updated successfully.": "Aggiornato con successo.",
  "added successfully.": "aggiunto con successo.",
  "Error occurred while adding user, please try again.": "Si è verificato un errore in fase di aggiunta di un utente, riprova.",
  "Invalid Controller": "Controllore non valido",
  "Select a Controller": "Seleziona un controllore",
  "Invalid Resource": "Risorsa non valida",
  "Select a Resource": "Seleziona una risorsa",
  "Invalid Min Value": "Valore min non valido",
  "Enter a valid Min Value.": "Immetti un valore min valido.",
  "Invalid Max Value": "Valore max non valido",
  "Enter a valid Max Value.": "Immetti un valore max valido.",
  "Invalid Max Distance Value": "Valore distanza max non valido",
  "Enter a valid Max Distance Value.": "Immetti un valore distanza max valido.",
  "Invalid Notify Mail Ids": "Id posta per notifiche non validi",
  "Enter valid mail Ids.": "Immetti ID posta validi.",
  "Select a valid controller in apply to section.": "Seleziona un controllore valido nella sezione ‘applica a’.",
  "Invalid Countries": "Paesi non validi",
  "Select one or more countries apply to section.": "Seleziona uno o più paesi nella sezione ‘applica a’.",
  "Invalid Rule Name": "Nome regola non valido",
  "Enter a valid rule name.": "Immetti un nome regola valido.",
  "added successfully": "aggiunto con successo",
  "updated successfully": "aggiornato correttamente",
  "Error occurred while adding/updating Rule, please try again.": "Si è verificato un errore in fase di aggiunta/aggiornamento di una Regola, riprova.",
  "Activated successfully": "Attivato con successo",
  "Deactivated successfully": "Disattivato correttamente",
  "Deleted successfully.": "Cancellato con successo.",
  "Are you sure to Delete Rule?": "Sei sicuro di voler cancellare la Regola?",
  "Invalid TenantName": "Nome concessionario non valido",
  "Tenant Name field should not be empty.": "Il campo nome concessionario non deve essere vuoto.",
  "Invalid ERP No": "N° ERP non valido",
  "ERP NO field should not be empty.": "Il campo N° ERP non deve essere vuoto.",
  "Invalid CoolersCount": "Conteggio apparecchi per la refrigerazione non valido",
  "Please enter valid Coolers": "Immetti apparecchi per la refrigerazione validi",
  "Invalid Cooler Value": "Valore apparecchio per la refrigerazione non valido",
  "Enter a valid Cooler Number Value.": "Immetti un valore numerico apparecchio per la refrigerazione valido.",
  "Invalid Expiry Date": "Data di scadenza non valida",
  "Please select Expiry Date": "Seleziona una data di scadenza",
  "Tenant added successfully.": "Concessionario aggiunto con successo.",
  "Error occurred while adding tenant, please try again.": "Si è verificato un errore in fase di aggiunta di un concessionario, riprova.",
  "Tenant Updated successfully.": "Concessionario aggiornato con successo.",
  "Error occurred while updating tenant, please try again.": "Si è verificato un errore in fase di aggiornamento di un concessionario, riprova.",
  "Reports": "Report",
  "Search works on Erp No, Tenant, Geo Location only": "cerca parole solo in Erp No, Tenant e Geo Location",
  "Update Tenant": "Aggiorna Tenant",
  "Select Expiry License Date": "Seleziona data scadenza licenza",
  "Registered Tenant": "Tenant registrati",
  "Registered Users": "Utenti registrati",
  "Users under Tenant": "Utenti presenti in Tenant",
  "Renewal notification sent to Tenant": "Notifiche di rinnovo inviate a Tenant",
  "Number of coolers under Tenant": "Numero di cooler presenti in  Tenant",
  "Date": "Data",
  "Choose Format": "Scegli formato",
  "Generate Report": "Genera report",
  "Select": "Seleziona",
  "Active Alarms": "Allarmi attivi",
  "Associated Resources": "Risorse associate",
  "Associated Users": "Utenti associati",
  "Coolers List": "Lista dei cooler",
  "Device": "Dispositivo",
  "User Device Information": "Informazioni sul dispositivo dell’utente",
  "Mobile Name": "Nome del cellulare",
  "Mobile Model": "Modello del cellulare",
  "Legal": "Ufficio legale",
  "Privacy Policy": "Informativa sulla privacy",
  "Copyright": "Copyright",
  "No Records found": "Nessun record trovato",
  "Billing Address": "Indirizzo Di Fatturazione",
  "Search works on Email, Mobile Name, Mobile Model": "la ricerca funziona con e-mail, nome mobile e modello mobile",
  "Are you sure to Delete ?": "Sei sicuro di cancellare?",
  "No results found!": "Nessun risultato trovato!",
  "Select Country": "Seleziona il paese",
  "Start Date": "Data d'inizio",
  "End Date": "Data di fine",
  "Select Start Date": "Seleziona la data di inizio",
  "Select End Date": "Seleziona la data di fine",
  "Invalid Start Date": "Data di inizio non valida",
  "Invalid End Date": "Data di fine non valida",
  "Invalid Controllers List": "Elenco controller non valido",
  "Please wait report is getting ready for Download": "Attendi che il rapporto si stia preparando per il download",
  "downloadFaild": "Impossibile scaricare",
  "Format": "Formato",
  "Controllers": "Controllori",
  "Downloads in Progress": "Download in corso",
  "Do you agree?": "Sei d'accordo?",
  "All the files downloaded Successfully": "Tutti i file scaricati correttamente",
  "No files found": "Nessun file trovato",
  "You have cancelled the Downloads": "Hai annullato i download",
  "Warning": "avvertimento",
  "Driver Manager": "Driver manager",
  "Driver File Name": "Nome file del driver",
  "Mask": "Maschera",
  "Uploaded By": "Caricato da",
  "Uploaded On": "Caricato il",
  "Are you sure to Delete Driver?": "Eliminare il driver?",
  "Please upload a valid file": "Carica un file valido",
  "Driver file already exists": "Il file del driver esiste già",
  "Are you sure you want to Overwrite?": "Sei sicuro di voler sovrascrivere?",
  "Download Success!": "Scarica Success!",
  "File Deleted Successfully": "File eliminato correttamente",
  "Trying to upload a non verified driver": "Tentativo di caricare un driver non verificato",
  "Driver File Uploaded": "File del driver caricato",
  "File name should not be more than 50 characters": "Il nome del file non deve contenere più di 50 caratteri",
  "Unit": "Unità",
  "Action": "Azione",
  "Bad Request": "Brutta richiesta",
  "Invalid input fields": "Campi di input non validi",
  "Invalid Tag Name": "Nome tag non valido",
  "Coolers by Country": "Refrigeratori per Paese",
  "Enable/Disable": "Abilita / Disabilita",
  "Actions": "Azioni",
  "Controller Model": "Modello del controllore",
  "Selected Resources Data": "Dati sulle risorse selezionate",
  "Last 24Hr": "Ultimi 24 ore",
  "View Data": "Visualizza dati",
  "Note: Maximum of 8 resources are allowed to view data": "Nota: al massimo 8 risorse possono visualizzare i dati",
  "Get Data": "Ottieni dati",
  "Until": "Fino a",
  "Tag Updated Successfully": "Tag aggiornato correttamente",
  "Add Tag Name..": "Aggiungi nome tag ...",
  "Select Tenant": "Sélectionnez le locataire...",
  "Tenant Disabled Successfully.": "Locatario disabilitato correttamente.",
  "Cooler moved successfully.": "Il dispositivo di raffreddamento si è spostato correttamente.",
  "Unknown error occurred, Please try again.": "Si è verificato un errore sconosciuto, riprova.",
  "No cooler/coolers availabe to move": "Nessun dispositivo di raffreddamento / raffreddamento disponibile per lo spostamento",
  "The target Tenant does not have enough space for the new coolers": "L'inquilino target non ha abbastanza spazio per il nuovo dispositivo di raffreddamento",
  "Tenant is not selected": "Il locatario non è selezionato",
  "Please select Tenant": "Seleziona il Locatario",
  "Select Countries": "Seleziona paesi",
  "Country List": "Elenco dei paesi",
  "Controller List": "Elenco dei controller",
  "Notified Email To": "Email notificata a",
  "Close": "Chiudi",
  "Disable": "disattivare",
  "Note: Once disabled you can not enable again.": "Nota: una volta disabilitato non è possibile abilitare nuovamente.",
  "Delete  Rule": "Elimina regola",
  "Delete Device": "Elimina dispositivo",
  "Ok": "Ok",
  "Hi": "Salve",
  "Commandes": "comandi",
  "Access Restricted Notice!": "avviso di accesso limitato",
  "Your License has expired. Please Contact your Admin.": "la licenza è scaduta. Prego contattare il vs amministratore",
  "Online": "connesso",
  "Offline": "disconnesso",
  "Total": "totale",
  "Processing...": "in elaborazione",
  "Request Process Successfully": "richiesta con successo",
  "Error occurred while processing request, please try again.": "si è verificato un errore durante l'elaborazione della richiesta, prego riprovare",
  "Menu": "Menu",
  "Device Groups": "Gruppi",
  "HACCP Report": "Report HACCP ",
  "Statistics": "Statistiche",
  "Device List": "Lista dispositivi",
  "All Devices": "tutti i dispositivi",
  "Search works on Device, Groups, Alarms, Country columns": "cerca",
  "Dongle UId": "Edge UID",
  "Active": "attivo",
  "Group(s)": "gruppi",
  "Device Details": "dettagli del dispositivo",
  "View Value": "visualizza valore",
  "Group Name": "Nome del gruppo",
  "Device Name": "nome del dispositivo",
  "Description": "Descrizione",
  "Created Date (UTC)": "Data di creazione (UTC)",
  "Added By": "aggiunto da ",
  "Search works on Group Name, Description columns": "cerca",
  "Add Group Details": "aggiungi dettagli al gruppo",
  "Edit Group Details": "Modifica i dettagli del gruppo",
  "Name of the Group": "Nome gruppo",
  "Create New Group": "Crea nuovo gruppo",
  "Select Devices": "Seleziona strumenti",
  "Group Information": "Informazioni sul gruppo",
  "Add Description": "Aggiungi descrizione",
  "Device Count": "Conteggio dispositivi",
  "Alarm Count": "Conteggio allarmi",
  "Device Status": "Stato del dispositivo",
  "Group Count": "Conteggio gruppo",
  "Device by Group": "Dispositivo per gruppo",
  "Alarms By Device Status": "Allarmi per stato del dispositivo",
  "Device Status Count": "Conteggio stato del dispositivo",
  "Alarms By Devices Over Time": "Allarmi per dispositivi nel tempo",
  "Real Time": "Real Time",
  "Last 24 Hrs": "Ultime 24 ore",
  "Last Week": "Ultima settimana",
  "Last Month": "Ultimo mese",
  "Last 3 Months": "Ultimi 3 mesi",
  "Last 1 Year": "Ultimo anno",
  "Last 6 Months": "Ultimi 6 mesi",
  "Devices": "Dispositivi",
  "OEM": "OEM",
  "Name": "Nome",
  "OEM\/Parent": "OEM\/Parent",
  "Create Users": "Crea utenti",
  "Selected Countries": "Paesi selezionati",
  "Selected Devices": "Dispositivi selezionati",
  "Enabled": "Abilitato",
  "Disabled": "Disabilitato",
  "Groups": "Gruppi",
  "Groups List": "Elenco gruppi",
  "Select Groups": "Seleziona gruppi",
  "Telemetry": "Telemetria",
  "Filters": "Filtri",
  "Show Favorites": "Mostra preferiti",
  "Favorites": "Preferiti",
  "Label": "Etichetta",
  "Current Value": "Valore corrente",
  "Operations": "Settore operativo",
  "Read All": "Leggi tutto",
  "Settings": "Impostazioni",
  "Set Value": "Imposta valore",
  "Mobile UId": "UId unità mobile",
  "Mobile OS | Version": "OS unità mobile | Versione",
  "Issued On": "Data emissione",
  "Active Device(s)": "Dispositivo\/i attivo\/i",
  "In-active Device(s)": "Dispositivo\/i inattivo\/i",
  "Block User": "Blocca utente",
  "Unblock User": "Sblocca utente",
  "Driver Upload": "Carica driver",
  "Search works on Driver File Name, Mask, and Uploaded By columns": "La ricerca funziona sulle colonne Nome file driver, Maschera e Caricato da",
  "Search works on Report Name,Report Frequency, and Notified Email columns": "La ricerca funziona sulle colonne Nome report, Frequenza report e E-mail di notifica",
  "Add new report": "Aggiungi nuovo report",
  "Report Name": "Nome report",
  "Report Frequency": "Frequenza report",
  "Daily": "Giornaliero",
  "Weekly": "Settimanale",
  "Monthly": "Mensile",
  "Data Frequency": "Frequenza dati",
  "PDF": "PDF",
  "CSV": "CSV",
  "XLSX": "XLSX",
  "Delete Report :": "Cancella report :",
  "Add Report": "Aggiungi report",
  "Update Report Details": "Aggiorna dettagli report",
  "Select Data Frequency": "Seleziona frequenza dati",
  "One time per day": "Una volta al giorno",
  "Two times per day": "Due volte al giorno",
  "Three time per day": "Tre volte al giorno",
  "Four times per day": "Quattro volte al giorno",
  "Select Device": "Seleziona dispositivo",
  "Data Frequency is Mandatory": "La frequenza dati è obbligatoria",
  "Device is Mandatory": "Il dispositivo è obbligatorio",
  "Resource is Mandatory": "La risorsa è obbligatoria",
  "Notified to email is Mandatory": "La notifica via e-mail è obbligatoria",
  "Maximum 8 resources can be selected": "È possibile selezionare un massimo di 8 risorse",
  "Invalid OEM": "OEM non valido",
  "Select an OEM": "Seleziona un OEM",
  "User already exist": "Utente già esistente",
  "Email or Role is not valid": "Email o Ruolo non valida\/o",
  "You are currently blocked. Please contact system administrator for details or to restore access. <System Admin EMAIL ID>": "Sei attualmente bloccato. Contatta l'amministratore del sistema per i dettagli o per ripristinare l'accesso. <System Admin EMAIL ID>",
  "Invalid Device": "Dispositivo non valido",
  "Invalid Group": "Gruppo non valido",
  "Error Deleting Alarm Rule": "Errore nella cancellazione della Regola dell’allarme",
  "Are you sure to Block ?": "Sei sicuro di voler Bloccare?",
  "Are you sure to Unblock ?": "Sei sicuro di voler Sbloccare?",
  "Error downloading driver file": "Errore nel download del file del driver",
  "Group deleted successfully": "Gruppo cancellato con successo",
  "Failed to delete group": "Cancellazione gruppo non riuscita",
  "Group created successfully": "Gruppo creato con successo",
  "Group details updated successfully": "Dettagli gruppo aggiornati con successo",
  "Failed to create\/edit group": "Impossibile creare\/modificare il gruppo",
  "Group Name already exist": "Nome gruppo già esistente",
  "Group Name already exist\/duplicate Group Name": "Nome gruppo già esistente\/duplica Nome gruppo",
  "Model is not valid": "Modello non valido",
  "Name\/Desc is not valid": "Nome\/Desc non valido\/a",
  "One\/More selcted device is invalid or the user doesn't have access": "Uno\/più dispositivi selezionati non sono validi o l'utente non ha accesso",
  "User has no access to the group": "L'utente non ha accesso al gruppo",
  "Failed to fetch data": "Impossibile recuperare i dati",
  "Error deleting file ": "Errore nell'eliminazione del report ",
  "Error occurred while adding\/updating Report, please try again.": "Si è verificato un errore in fase di aggiunta\/aggiornamento di un Report, riprova.",
  "Are you sure to Delete Report?": "Sei sicuro di voler cancellare  il Report?",
  "Error Deleting Report": "Errore nell'eliminazione del Report",
  "User has no access to the Haccp Report": "L'utente non ha accesso al report Haccp",
  "Report name is not valid": "Nome report non valido",
  "Invalid Controller type": "Tipo di controller non valido",
  "Duplicate report name": "Duplica nome report",
  "Support": "Supporto",
  "FAQ's": "FAQ's'",
  "Add OEM": "Aggiungi l'OEM",
  "History": "Storia",
  "Version": "Versione",
  "v3.2": "v3.2",
  "Terms and Conditions": "Termini e Condizioni",
  "Search works on OID,OEM Name,OEM Description": "La ricerca funziona su OID, nome OEM, descrizione OEM",
  "OEM Description": "Descrizione OEM",
  "OEM Name": "nome OEM",
  "OID": "OID",
  "Map View": "Vista mappa",
  "Report HACCP": "Rapporto HACCP",
  "Export Json": "Esporta Json",
  "Phone/Tablet": "Telefono/Tablet",
  "Data Export": "Esportazione dati",
  "Management": "Gestione",
  "Home": "Home",
  "Count": "Contare",
  "Commands": "Comandi",
  "Added On": "Aggiunto",
  "Modbus slave ID": "ID slave Modbus",
  "Controller Type Name": "Nome tipo controllore",
  "Device Type": "Tipo di apparecchio",
  "Groups Count": "Conteggio gruppo",
  "Day": "Giorno (DAY)",
  "Hour": "Ora",
  "Start": "Inizio",
  "End": "Fine",
  "Poli": "Poli",
  "Mask": "Maschera",
  "Release": "Rilascio",
  "PCH": "PCH",
  "Location": "locazione",
  "Dsp Id": "ID dsp",
  "Firmware Version": "Versione firmware",
  "Device Metadata": "Metadati apparecchio",
  "Alarms count by device's status": "Conteggio allarmi per stato dell'apparecchio",
  "Alarms count group by device's status and device": "Gruppo conteggio allarmi per stato dell'apparecchio e apparecchio",
  "Alarm Count distribution over time": "Distribuzione nel tempo del conteggio allarmi",
  "Alarm status count over time": "Conteggio stato allarmi nel corso del tempo",
  "Device by Controller Model": "Apparecchio per modello di controllore",
  "Select columns": "Seleziona colonne",
  "columns selected": "colonne selezionate",
  "Favourites": "Favoriti"


}
